<template>
    <div>
        <base-crud
                crudName="Questões"
                newText="Nova Questão"
                :table="questionTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="true"
                :enableEdit="false"
                :enableDelete="false"
                :enableView="true"
                :enableSetStatus="false"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                questionTable: 'questionTable',
                materials: [],
                pages: [],
                url: '',
                columns: ['id', 'description', 'actions'],
                tableData: ['id', 'description', 'actions'],
                options: {
                    sortable: ['id'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll'},
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    templates: {},
                    headings: {
                        'description': 'Descrição',
                    }
                },
                endPoint: 'question/'
            }
        },
        components: {
            BaseCrud
        }
    }
</script>

<style scoped>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Question/Crud.vue